import { getCommodityIconSrc, getEcoOrGasNewPlansName } from "../../common";
import { iconStyles } from "../styles/cardStyles";
import { S3_BUCKET } from "../../config";
import { PlanType } from "../../types/planType";

const RenderPlanIcon = ({
  plan,
  utilityName,
}: {
  plan: PlanType;
  utilityName: string;
}) => {
  const responsiveIconStyles = {
    ...iconStyles,
    width: "clamp(50px, 8vw, 50px)",
    height: "clamp(50px, 8vw, 50px)"
  };

  return (
    <div style={{ margin: "0 .25rem" }}>
      {plan?.ef_plan_details?.electric_savings ? (
        <img src={"/icon/featured-gas.png"} alt="Icon" style={responsiveIconStyles} />
      ) : plan.ef_plan_details?.icon_file &&
        plan.ef_plan_details?.callout_text ? (
        <img
          src={S3_BUCKET + plan.ef_plan_details?.icon_file}
          alt="Icon"
          style={responsiveIconStyles}
        />
      ) : Boolean(getEcoOrGasNewPlansName(plan.plan_name, utilityName)) ? (
        <div className="renewable_type me-2">
          <img
            src={getCommodityIconSrc(
              getEcoOrGasNewPlansName(plan.plan_name, utilityName)
            )}
            alt={plan.commodity_clean_name}
            style={responsiveIconStyles}
          />
        </div>
      ) : plan.commodity_clean_name ? (
        <div className="renewable_type me-2">
          <img
            src={getCommodityIconSrc(plan.commodity_clean_name)}
            alt={plan.commodity_clean_name}
            style={responsiveIconStyles}
          />
        </div>
      ) : plan.plan_name.toLowerCase().includes("easy") ? (
        <div className="renewable_type me-2">
          <img
            src={getCommodityIconSrc("easy")}
            alt={plan.commodity_clean_name}
            style={responsiveIconStyles}
          />
        </div>
      ) : (
        <div className="renewable_type me-2">
          <img
            src={
              plan.commodity_name === "Electric"
                ? "/icon/icon_green.svg"
                : "/images/icon_gas.png"
            }
            alt={plan.commodity_clean_name}
            style={responsiveIconStyles}
          />
        </div>
      )}
    </div>
  );
};

export default RenderPlanIcon;
